import { render, staticRenderFns } from "./XmlMessageList.vue?vue&type=template&id=5b1abcc4"
import script from "./XmlMessageList.vue?vue&type=script&lang=js"
export * from "./XmlMessageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b1abcc4')) {
      api.createRecord('5b1abcc4', component.options)
    } else {
      api.reload('5b1abcc4', component.options)
    }
    module.hot.accept("./XmlMessageList.vue?vue&type=template&id=5b1abcc4", function () {
      api.rerender('5b1abcc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/XmlViewer/XmlMessageList.vue"
export default component.exports